import { useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Card, Stack, Typography, Link, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { RootState } from 'src/redux/store';
import { postAdminLogin } from 'src/redux/slices/adminAuth';
import { PATH_ADMIN } from 'src/routes/paths';

type FormValuesProps = {
  email: string;
  senha: string;
};

export default function AdminLoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminAuth = useSelector((state: RootState) => state.adminAuth);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required('O email é obrigatório').email('Digite um email válido'),
    senha: Yup.string().required('Senha é obrigatória'),
  });

  const methods = useForm<FormValuesProps>({
    resolver: yupResolver(LoginSchema),
    defaultValues: { email: '', senha: '' },
  });

  const { handleSubmit } = methods;

  const onSubmit = (data: FormValuesProps) => {
    dispatch(postAdminLogin(data));
  };

  useEffect(() => {
    if (adminAuth.accessToken) {
      navigate(PATH_ADMIN.saques);
    }
  }, [adminAuth.accessToken, navigate]);

  return (
    <>
      <Helmet>
        <title>Login admin | Hop</title>
      </Helmet>

      <Container maxWidth="xs" sx={{ py: 10 }}>
        <Card sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ mb: 3 }}>
            Painel Hop — acesso da equipe
          </Typography>

          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2}>
              <RHFTextField name="email" label="Email" />
              <RHFTextField name="senha" label="Senha" type="password" />

              {adminAuth.error && <Alert severity="error">{adminAuth.error}</Alert>}

              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                loading={adminAuth.isLoading}
              >
                Entrar
              </LoadingButton>

              <Link component={RouterLink} to={PATH_ADMIN.register} variant="body2" textAlign="center">
                Criar conta de admin
              </Link>
            </Stack>
          </FormProvider>
        </Card>
      </Container>
    </>
  );
}
